import UnitLabels from "./unit-labels.enum";

const relations = [
  {
    unit: "UNID",
    options: [
      "UND",
      "UNIDADE",
      "UNITARIO",
      "UN",
      "UN.",
      "UNIT",
      "UNI",
      "1UND",
      "UNID.",
      "1 UNI",
      "UNI",
      "UNIDAD",
      "UNITY"
    ]
  },
  { unit: "AMPOLA", options: ["AMPL", "AMPOL", "AMP"] },
  { unit: "BALDE", options: ["BLD", "BAUDE", "BALD", "BUCKET"] },
  { unit: "BANDEJ", options: ["BANDEJA", "BANDJA", "BANDJ", "TRAY"] },
  { unit: "BARRA", options: ["BARA", "BAR"] },
  {
    unit: "BISNAG",
    options: ["BISNAGA", "BIZNAGA", "BYSNAGA", "BYZNAGA", "BISN"]
  },
  { unit: "BLOCO", options: ["BLOKO", "BLOC", "BL", "BLOCK"] },
  { unit: "BOBINA", options: ["BOBIN", "BOBYNA", "COIL", "REEL"] },
  { unit: "BOMB", options: ["BOMBONA", "BOMBON"] },
  { unit: "CAPS", options: ["CAPSULA", "CAPÇULA", "KAPSULA", "CAPSULE"] },
  { unit: "CART", options: ["CARTELA"] },
  { unit: "CENTO", options: ["SENTO", "CEMTO", "CENT", "HUNDRED"] },
  { unit: "CJ", options: ["CONJUNTO", "COMJUMTO", "CONJUNTU", "CONJ", "SET"] },
  { unit: "CM", options: ["CENTIMETRO", "CEMTIMETRO", "CENTIMETER"] },
  {
    unit: "CM2",
    options: [
      "CM_2",
      "CENTIMETRO2",
      "CEMTIMETRO2",
      "CENTIMETRO_2",
      "CEMTIMETRO_2",
      "CENTIMETER_2"
    ]
  },
  { unit: "CX", options: ["CAIXA", "CAXA", "CASHA", "CXS", "CAXA", "CASHIER"] },
  {
    unit: "CX2",
    options: [
      "CAIXA2",
      "CAIXA_2",
      "CAXA2",
      "CAXA_2",
      "CASHA2",
      "CASHA_2",
      "CASHIER2",
      "CASHIER_2"
    ]
  },
  {
    unit: "CX3",
    options: [
      "CAIXA3",
      "CAIXA_3",
      "CAXA3",
      "CAXA_3",
      "CASHA3",
      "CASHA_3",
      "CASHIER3",
      "CASHIER_3"
    ]
  },
  {
    unit: "CX5",
    options: [
      "CAIXA5",
      "CAIXA_5",
      "CAXA5",
      "CAXA_5",
      "CASHA5",
      "CASHA_5",
      "CASHIER5",
      "CASHIER_5"
    ]
  },
  {
    unit: "CX10",
    options: [
      "CAIXA10",
      "CAIXA_10",
      "CAXA10",
      "CAXA_10",
      "CASHA10",
      "CASHA_10",
      "CASHIER10",
      "CASHIER_10"
    ]
  },
  {
    unit: "CX15",
    options: [
      "CAIXA15",
      "CAIXA_15",
      "CAXA15",
      "CAXA_15",
      "CASHA15",
      "CASHA_15",
      "CASHIER15",
      "CASHIER_15"
    ]
  },
  {
    unit: "CX20",
    options: [
      "CAIXA20",
      "CAIXA_20",
      "CAXA20",
      "CAXA_20",
      "CASHA20",
      "CASHA_20",
      "CASHIER20",
      "CASHIER_20"
    ]
  },
  {
    unit: "CX25",
    options: [
      "CAIXA25",
      "CAIXA_25",
      "CAXA25",
      "CAXA_25",
      "CASHA25",
      "CASHA_25",
      "CASHIER25",
      "CASHIER_25"
    ]
  },
  {
    unit: "CX50",
    options: [
      "CAIXA50",
      "CAIXA_50",
      "CAXA50",
      "CAXA_50",
      "CASHA50",
      "CASHA_50",
      "CASHIER50",
      "CASHIER_50"
    ]
  },
  {
    unit: "CX100",
    options: [
      "CAIXA100",
      "CAIXA_100",
      "CAXA100",
      "CAXA_100",
      "CASHA100",
      "CASHA_100",
      "CASHIER100",
      "CASHIER_100"
    ]
  },
  { unit: "DISP", options: ["DISPLAY", "DISPLEY", "DISPLEI", "DYSPLEY"] },
  { unit: "DUZIA", options: ["DZ", "1 DZ", "DUSIA", "DOZEN"] },
  {
    unit: "EMBAL",
    options: ["EMB", "EMBALAGEM", "ENBALAGEM", "EMBALAJEM", "PACKING"]
  },
  { unit: "FARDO", options: ["FARDU", "FRD", "BURDEN"] },
  { unit: "FOLHA", options: ["FLH", "FOLIA", "SHEET"] },
  { unit: "FRASCO", options: ["FRASKO", "FLASK"] },
  { unit: "GALAO", options: ["GALAUM", "GALLON"] },
  { unit: "GF", options: ["GARRAFA", "GARAFA", "GRF", "BOTTLE"] },
  { unit: "GRAMAS", options: ["GRMS", "GRM", "GRAMS"] },
  { unit: "JOGO", options: ["JOG", "SET"] },
  {
    unit: "KG",
    options: [
      "QUILOGRAMA",
      "QUILO",
      "QUILOS",
      "KILOGRAMA",
      "KILO",
      "KILOGRAM",
      "1KG",
      "KGS",
      "KG.",
      "KLG",
      "1000GR"
    ]
  },
  { unit: "KIT", options: ["KITE", "QUIT"] },
  { unit: "LATA", options: ["CAN"] },
  {
    unit: "LITRO",
    options: ["LITRU", "1LITRO", "LTR", "LITER", "1 L", "1 LT", "LITRE"]
  },
  { unit: "M", options: ["METRO", "METER", "METRE"] },
  {
    unit: "M2",
    options: ["METRO2", "METRO_2", "METER2", "METER_2", "METRE2", "METRE_2"]
  },
  {
    unit: "M3",
    options: [
      "METRO3",
      "METRO_3",
      "MTS³",
      "METER3",
      "METER_3",
      "METRE3",
      "METRE_3"
    ]
  },
  { unit: "MILHEI", options: ["MILHEIRO", "MILHERO"] },
  { unit: "ML", options: ["MILILITRO", "MILILITER", "MILILITRE"] },
  {
    unit: "MWH",
    options: [
      "MEGAWATT HORA",
      "MEGAWATT_HORA",
      "MEGAWATT HOUR",
      "MEGAWATT_HOUR"
    ]
  },
  { unit: "PACOTE", options: ["PACOT", "PCT", "PACKAGE"] },
  { unit: "PALETE", options: ["PALLET"] },
  { unit: "PARES", options: ["1PAR", "PAIRS"] },
  {
    unit: "PC",
    options: ["PEÇA", "PECA", "PESSA", "PCS", "PCA", "PEÇS", "PÇA", "PIECE"]
  },
  { unit: "POTE", options: ["POT"] },
  { unit: "K", options: ["QUILATE", "CARAT"] },
  { unit: "RESMA", options: ["RESM", "REAM"] },
  { unit: "ROLO", options: ["RL", "ROLL"] },
  { unit: "SACO", options: ["SC", "BAG"] },
  { unit: "SACOLA", options: ["SCL"] },
  { unit: "TAMBOR", options: ["TMBR", "TAMBR", "TBR", "BARREL"] },
  { unit: "TANQUE", options: ["TNQ", "TANKE", "TANK"] },
  { unit: "TON", options: ["TONELADA"] },
  { unit: "TUBO", options: ["TB", "TUBE"] },
  { unit: "VASIL", options: ["VSLHM", "VASILHAME"] },
  { unit: "VIDRO", options: ["VDR", "GLASS"] }
];

export default raw_unit => {
  const unit = `${raw_unit}`.toUpperCase();

  if (UnitLabels[unit]) {
    return unit;
  }

  for (const relation of relations) {
    if (relation.options.includes(unit)) {
      return relation.unit;
    }
  }

  return "UNID";
};



// WEBPACK FOOTER //
// ./src/core/enum/unit-labels-relationships.enum.js